import { createFeatureSelector, createSelector } from '@ngrx/store';
import { currencyFeatureKey, CurrencyState } from './currencycode.reducers';

export const currencyCodeSelector = createFeatureSelector<CurrencyState>(currencyFeatureKey);

export const selectCustomerCurrency = createSelector(currencyCodeSelector, (state: CurrencyState) => state.customerCurrencyCode ?? null);

export const selectContractCurrency = createSelector(currencyCodeSelector, (state: CurrencyState) => state.contractsCurrencyCode ?? null);
